import React, {Component} from "react";
import Form from 'react-validation/build/form';
import Input from 'react-validation/build/input';
import Button from 'react-validation/build/button';
import validator from "validator";
import Loading from "../../components/Loading";
import Xhr from "../../helpers/Xhr";
import {Link} from "react-router-dom";

class UserRestore extends Component {
	state = {
		form     : {
			csrf             : '',
			password         : null,
			password_confirm : null
		},
		messages : []
	};

	componentWillMount() {
		Xhr.restorePassword(this.props.hash).then((resp) => {
			if ( resp.data.hasOwnProperty('form') ) {
				this.setState({form : {...resp.data.form}});
			}
		});
	}

	errorBox(message) {
		return <div className="error">{message}</div>
	}

	required(value) {
		if ( value === null || validator.isEmpty(value) ) {
			return this.errorBox('Поле обязательно для заполнения!');
		}
	};

	passEquals(value) {
		if ( value.toString().trim() !== this.state.form.password.toString().trim() ) {
			return this.errorBox('Пароли не совпадают!');
		}
	}

	minLength(value) {
		if ( value.toString().trim().length < 6 ) {
			return this.errorBox('Минимум 6 букв и/или цифр!')
		}
	}

	changePasswordValue(e) {
		this.setState({
			form : {...this.state.form, password : e.target.value}
		});
	}

	changeRepeatPasswordValue(e) {
		this.setState({
			form : {...this.state.form, password_confirm : e.target.value}
		});
	}

	changePassword(e) {
		e.preventDefault();
		Xhr.restorePasswordPost(this.props.hash, this.state.form).then((resp) => this.setState({messages : resp.data}));
	}

	render() {
		const messages = <div className="forgot__restore-messages">
			{this.state.messages.map((message) => <div>{message}</div>)}
			<div>Перейти на <Link to={'/'}>главную страницу</Link></div>
		</div>;

		return (
			<div className="body__container__side-right">
				<div className="live-event-header result-live__header">
					<div className="no-dot">Изменение пароля</div>
				</div>

				{this.state.messages.length > 0 ? messages :
					<Form ref={c => { this.form = c }} onSubmit={this.changePassword.bind(this)}>
						<div className="forgot restore">
							<div className="forgot__input">
								<Input id="password"
								       type="password"
								       placeholder="Новый пароль"
								       validations={[this.required.bind(this), this.minLength.bind(this)]}
								       onChange={this.changePasswordValue.bind(this)}
								       value={this.state.form.password}/>

								<Input id="repeat-password"
								       type="password"
								       placeholder="Повторите пароль"
								       validations={[this.required.bind(this), this.passEquals.bind(this), this.minLength.bind(this)]}
								       onChange={this.changeRepeatPasswordValue.bind(this)}
								       value={this.state.form.password_confirm}/>
							</div>
						</div>

						<div className="buttons forgot__buttons">
							<Button className="buttons__show">Изменить пароль</Button>
						</div>
						<div className="forgot__loading">{this.state.fetching && <Loading/>}</div>
					</Form>
				}
			</div>
		);
	}
}

export default UserRestore;


// WEBPACK FOOTER //
// ./src/app/pages/User/UserRestore.js